'use strict';

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;



/*****************
 ** WEBPACK FOOTER
 ** ./~/gopd/index.js
 ** module id = 640
 ** module chunks = 73
 **/